// extracted by mini-css-extract-plugin
export var completionBody = "_mb-2";
export var completionCard = "_mb-0";
export var completionFooter = "_mb-3";
export var completionTitle = "_mb-1";